import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';

function deepCopy(obj: object): object {
  return JSON.parse(JSON.stringify(obj));
}

@Component({
  selector: 'app-modifier',
  templateUrl: './modifier.component.html',
  styleUrls: ['./modifier.component.scss']
})
export class ModifierComponent implements OnInit, OnChanges {

  @Input() audiometryInput: any;
  @Input() presetFilters: any;
  @Input() ageCentile: any;
  @Output() modifierUpdated = new EventEmitter();

  activeTab = 1;
  leftConfig: any = {
    "arhlParam": {
      "changeAgeTo": "",
      "changeCentileTo": "",
      "arhlParam": ""
    },
    "exposure": {
      "exposure": "",
      "newDbValue": ""
    },
    "anchor": {
      "changeAnchorPoints": "",
      "newLowerAnchor": "",
      "newUpperAnchor": ""
    }
  };
  rightConfig: any = {
    "arhlParam": {
      "changeAgeTo": "",
      "changeCentileTo": "",
      "arhlParam": ""
    },
    "exposure": {
      "exposure": "",
      "newDbValue": ""
    },
    "anchor": {
      "changeAnchorPoints": "",
      "newLowerAnchor": "",
      "newUpperAnchor": ""
    }
  };

  isoTypeList = [{ id: 'guideline', title: 'Guidelines' }, { id: 'iso2000', title: 'ISO7029:2000' }, { id: 'iso2017', title: 'ISO7029:2017' }];
  standard: string = "guideline";
  newDbValue: number;
  exposureValue: number;
  yearsExposedToNoise: number;

  constructor() { }

  ngOnInit(): void {
    // console.log('presetFilters');
    if (this.presetFilters) {
      // console.log(this.presetFilters)
      // console.log('received data from parent : '+ this.presetFilters )
    }
  }

  updateValueInConfig(cva: any) {
    if (this.rightConfig && cva.right) {
      this.rightConfig.arhlParam.changeAgeTo = cva.right.age;
      this.rightConfig.arhlParam.changeCentileTo = cva.right.centile
    }
    if (this.leftConfig && cva.left) {
      this.leftConfig.arhlParam.changeAgeTo = cva.left.age;
      this.leftConfig.arhlParam.changeCentileTo = cva.left.centile
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // if (changes['audiometryInput']) {
    //   this.audiometryInput = changes['audiometryInput'].currentValue; 
    // }
    if (changes['ageCentile']) {
      let cva = changes["ageCentile"].currentValue;
      this.updateValueInConfig(cva);
    }
    if (changes['presetFilters']) {
      let cv = changes["presetFilters"].currentValue;
      if (cv) {
        let { left, right } = cv;
        this.rightConfig = right?.calcJson;
        this.leftConfig = left?.calcJson;
        this.standard = right?.reportType || left?.reportType || "guideline";
      }
      this.initExposureAndNotional();
    }
    // console.log(this.audiometryInput)  
    // console.log(this.presetFilters)
    // console.log(this.ageCentile)
  }


  rightModifierUpdated($event: any): void {
    this.rightConfig = $event;
    this.modifierChanged('right');
  }
  leftModifierUpdated($event: any): void {
    this.leftConfig = $event;
    this.modifierChanged('left');
  }
  modifierChanged(changedTab?: any): void {
    let tempConfig = {
      "reportType": this.standard,
      "calcJson": {
        "exposure": {
          "exposure": this.exposureValue,
          "newDbValue": this.newDbValue,
          "yearsExposedToNoise": this.yearsExposedToNoise
        }
      }
    }
    let config: any = {
      right: deepCopy(tempConfig),
      left: deepCopy(tempConfig)
    };
    if (this.rightConfig) {
      let { exposure, ...remainingConfigRight } = this.rightConfig;
      config.right['calcJson'] = Object.assign(config.right['calcJson'], remainingConfigRight);
    }
    if (this.leftConfig) {
      let { exposure, ...remainingConfigLeft } = this.leftConfig;
      config.left['calcJson'] = Object.assign(config.left['calcJson'], remainingConfigLeft);
    }
    this.modifierUpdated.emit(config);
  }

  //Handling Standard changes
  onStandardChange(val: string) {
    this.standard = val;
    this.modifierChanged();
  }

  //Handling Exposure and Notional changes start
  initExposureAndNotional() {
    if (this.presetFilters && JSON.stringify(this.presetFilters) != "{}") {
      this.exposureValue = this.presetFilters?.right?.calcJson?.exposure?.exposure ||
        this.presetFilters?.left?.calcJson?.exposure?.exposure ||
        1;
      this.newDbValue = this.presetFilters?.right?.calcJson?.exposure?.newDbValue ||
        this.presetFilters?.left?.calcJson?.exposure?.newDbValue ||
        this.audiometryInput?.notionalExposure;
      this.yearsExposedToNoise = this.presetFilters?.right?.calcJson?.exposure?.yearsExposedToNoise || this.presetFilters?.left?.calcJson?.exposure?.yearsExposedToNoise || this.audiometryInput?.yearsExposedToNoise;
    } else {
      this.exposureValue = 1;
      this.newDbValue = this.audiometryInput?.notionalExposure;
      this.yearsExposedToNoise = this.audiometryInput?.yearsExposedToNoise;
    }
  }

  buttonSwitchClickExpo(optionId: any) {
    this.exposureValue = optionId;
    if (optionId == '1') {
      this.newDbValue = this.audiometryInput?.notionalExposure
      this.yearsExposedToNoise = this.audiometryInput?.yearsExposedToNoise;
    }
    if (optionId == '2') {
      this.newDbValue = this.presetFilters?.right?.calcJson?.exposure?.newDbValue ||
        this.presetFilters?.left?.calcJson?.exposure?.newDbValue ||
        this.audiometryInput?.notionalExposure
      this.yearsExposedToNoise = this.presetFilters?.right?.calcJson?.exposure?.yearsExposedToNoise || this.presetFilters?.left?.calcJson?.exposure?.yearsExposedToNoise || this.audiometryInput?.yearsExposedToNoise || this.audiometryInput?.yearsExposedToNoise;
    }
    this.modifierChanged();
  }

  isCheckedExpo(value: any): boolean {
    if (this.exposureValue == value) {
      return true;
    }
    return false;
  }

  hasErrorNotional(): boolean {
    if (this.newDbValue >= 85 && this.newDbValue <= 125) {
      return false;
    }
    return true;
  }

  onNotionalChange(val: number) {
    this.newDbValue = val;
    this.exposureValue = 2;
    if (!this.hasErrorNotional()) {
      this.modifierChanged();
    }
  }
  //Handling Exposure and Notional changes end

  // years exposed to noise 
  hasErrorYearsExposedToNoise(): boolean {
    if (this.yearsExposedToNoise >= 1 && this.yearsExposedToNoise <= 49) {
      return false;
    }
    return true;
  }

  onYearsExposedToNoiseChange(val: number) {
    this.yearsExposedToNoise = val;
    this.exposureValue = 2;
    if (!this.hasErrorYearsExposedToNoise()) {
      this.modifierChanged();
    }
  }

}
